				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class AppUserService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('AppUser');
	}
	
	loadAllForPerson(id: System.Guid) : Observable<TooBig4Car.Logic.AppUser[]> {
		return this.myBaseService.loadAll(this.url + '/ForPerson/' + (id || ''));
	}
}
				
